import React from "react";
import { Link } from "react-router-dom";
import esDict from "@/locales/ec.json";

/**
 * 404 fallback. Uses Spanish by default.
 */
export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex items-center">
      <div className="max-w-xl mx-auto px-6 py-24 text-center">
        <p className="text-xs font-mono uppercase tracking-widest text-blue-400 mb-3">
          404
        </p>
        <h1 className="text-3xl sm:text-4xl font-bold text-white tracking-tight">
          {esDict.thankYou.title.startsWith("Gracias") ? "Página no encontrada" : "Page not found"}
        </h1>
        <p className="mt-3 text-slate-300">
          {esDict.thankYou.title.startsWith("Gracias")
            ? "La página que buscas no existe o ha sido movida."
            : "The page you are looking for does not exist or has been moved."}
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center justify-center rounded-md bg-blue-600 hover:bg-blue-500 text-white font-semibold px-6 py-3 transition-colors"
        >
          {esDict.thankYou.backHome}
        </Link>
      </div>
    </div>
  );
}
